import TechnicalDataTab from './TechnicalDataTab'
import technicalDataTabContainer from './technicalDataTabContainer'

export default technicalDataTabContainer(TechnicalDataTab)
